/**
 * Perfoms a credit check to ensure that the user has enough credits to place an order. If the user does not have enough credits, the order will not be placed.
 */
var handleError = function (err) {
    console.error(err);
    return new Response(JSON.stringify({
      code: 400,
      message: 'Network Error'
    }));
  };

export default async function doCreditCheck(accountid, credit, price, sDispatch) {
  try {
    const url = process.env.REACT_APP_FIND_API + '/order/getspent?accountid=' + encodeURIComponent(accountid);
    const res = await fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });
    if (!res || !res.ok) throw new Error('Failed to fetch spent amount');
    const data = await res.json();

    const spent = parseFloat(data.spent || 0);
    const p = parseFloat(price || 0);
    const limit = parseFloat(Number(credit) * 1.2);

    // true when there is enough credit (spent + price is less than allowed limit)
    const hasEnoughCredit = ((spent + p) < limit) ? true : false;

    if (sDispatch) {
      // original logic: when condition true -> creditReached: false
      if (hasEnoughCredit) {
        sDispatch({ type: 'setMonthlyBalance', payload: { monthlybalance: parseFloat(spent + p) } });
      } else {
        //Not enough credit, set creditReached to true
        sDispatch({ type: 'creditReached', payload: { creditReached: true } });
      }; 
    }
    return hasEnoughCredit;
  } catch (err) {
    handleError(err);
    return false;
  }
}